import { apiCall, createQueryString } from "./../imports"
const PREFIX = "management/home"

export default {

    getInfo() {
        return apiCall('get', `${PREFIX}`);
    },
}